import { application } from "./application"
import RefreshController from "./refresh_controller"
import AiReviewController from "./ai_review_controller"
import RemoteModalController from "./remote_modal_controller"

application.register("refresh", RefreshController)
application.register("ai-review", AiReviewController)
application.register("remote-modal", RemoteModalController)
